import { useCallback, useRef, useState } from "react";
import { DataMessages, useData, useDataEvents } from "../core/hooks/useData";
import { closestIndex, closestKey } from "../core/utils/dom";
import { usePresenter } from "./types";

export function Choices(props: {
	choices: string[],
	propToSet: string,
}) {
	const data = useData<any>();

	const items = [];
	for(let c of props.choices) {
		items.push(
			<div
				key={c}
				className="tag option interactive"
				data-key={c}
			>
				{c}
			</div>
		)
	}

	function handleClick(e: any) {
		const key = closestKey(e.target, ".option");
		if (!key) return;

		data.setValue(props.propToSet, key);
	}

	const visible = useRef(true);
	const [,refresh] = useState({});

	useDataEvents(data, useCallback((msg) => {
		if (msg.type === DataMessages.CHANGE) {
			const val = data.value[props.propToSet];
			const hasValue = (val && val.length > 0);
			if (visible.current !== !hasValue) visible.current = !hasValue;
			refresh({});
		}
	}, []));

	if (!visible.current) return null;

	return (
		<div className="flex horiz gap-2 wrap padding-bottom-2" onClick={handleClick}>
			{items}
		</div>
	)
}